import type { PersonDto, PersonUpdateRequest } from "../dto/PersonDto";
import type { Person, UpdatePersonCommand } from "@domain/model/Person";
import { asPersonId } from "@domain/model/Ids";
import { asDate, iso } from "@domain/model/Time";

export const personFromDto = (d: PersonDto): Person => ({
  id: asPersonId(d.id),
  displayName: d.displayName,
  preferredName: d.preferredName,
  mobilePhoneE164: d.mobilePhoneE164,
  email: d.email,
  canAppearInPhoto: d.canAppearInPhoto,
  version: d.version,
  createdAt: asDate(d.createdAt),
  updatedAt: asDate(d.updatedAt),
  deletedAt: d.deletedAt ? asDate(d.deletedAt) : null,
});

export const personToDto = (p: Person): PersonDto => ({
  id: p.id,
  displayName: p.displayName,
  preferredName: p.preferredName,
  mobilePhoneE164: p.mobilePhoneE164,
  email: p.email,
  canAppearInPhoto: p.canAppearInPhoto,
  version: p.version,
  createdAt: iso(p.createdAt),
  updatedAt: iso(p.updatedAt),
  deletedAt: p.deletedAt ? iso(p.deletedAt) : null,
});

export const updatePersonRequestFromCommand = (
  cmd: UpdatePersonCommand,
): PersonUpdateRequest => ({
  displayName: cmd.displayName ?? null,
  preferredName: cmd.preferredName ?? null,
  mobilePhoneE164: cmd.mobilePhoneE164 ?? null,
  email: cmd.email ?? null,
  canAppearInPhoto: cmd.canAppearInPhoto ?? null,
});
